var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{staticClass:"tag",attrs:{"size":_vm.size,"type":_vm.type},on:{"click":_vm.handleTagClicked}},[_vm._v("\n  "+_vm._s(_vm.tagName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }